<div class="header">
  <img src="../../../assets/images/logo/flowtrics_logo.png">
</div>

<div class="container">
 

<!-- For requested docuemnts -->
  <div class="requestholder">
    <div class="info">
      <div class="requestedby mb">
        <span class="head">Requested Documents<span class="count">{{folderList.length}}</span></span>
        <!-- <span class="text-grey">Expires on: {{requestExpiryDate | date:'MM/dd/yyyy'}}</span> -->
      </div>

      <div class="welcome mb">
        <p>Hey <b></b></p>
        <p><span class="name">{{senderFirstName|titlecase}} {{senderLastName|titlecase}}</span> has requested documentation. 
          <!-- Please upload before {{requestExpiryDate | date:'MM/dd/yyyy'}}. -->
        </p>
      </div>

      <div class="message mb">
        <p><b>Subject</b></p>
        <p>{{subject}}</p>
      </div>

      <div class="message mb">
        <p><b>Message</b></p>
        <p class="multi_lines_text" [innerHTML]="message"></p>
        <!-- <p>{{message}}</p> -->
      </div>

    </div>


    <div class="documentcontainer">
      <ul>
        <li  *ngFor="let document of folderList; let i = index">
          <ng-container *ngIf="!document.documentType">
          
          <div class="documentList" >
            <div class="uploadholder">
              <mat-icon>backup</mat-icon>
              <p>{{document.placeholderName}}</p>
              <span>Drag & Drop here</span>
              <input type="file" [disabled]="status" matTooltipClass="tooltip" matTooltip="{{document.placeholderName}}"
              (change)="UploadFile($event,document)">
            </div>
            <div class="uplsub">
              <input [disabled]="status" #Input hidden="true" type="file" onclick="this.value=null" (change)="UploadFile($event,document)"/>
              <button [disabled]="status" class="upload" mat-stroked-button color="primary" matTooltip="Upload" (click)="Input.click()" matTooltipClass="tooltip">                
                Upload
              </button>              
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="document.documentType">
           
          <div class="documentList">
            <div class="download" (click)="DownloadFile(document)">
              <mat-icon>attach_file</mat-icon>
              Download
            </div>
            <div class="uploadholder">

              <span class="type" *ngIf="document.documentType == 'pdf' || document.documentType == '.pdf'">
                <img width="40" src="../../../../../assets/icons/fileType/pdf_icon.svg" alt="Pdf File" />
               </span>
    
              <span class="type" *ngIf="document.documentType == 'doc' ||
                  document.documentType == 'docx'">
                  <img width="40" src="../../../../../assets/icons/fileType/doc_icon.svg" alt="Word File"/>
               </span>
    
              <span class="type" *ngIf="document.documentType == 'xlsx' ||
                  document.documentType == 'xls' ||
                  document.documentType == 'csv' ||
                  document.documentType == 'ods'">
                <img width="40" src="../../../../../assets/icons/fileType/excel_icon.svg" alt="excel File"/>
              </span>

              <span class="type" *ngIf="document.documentType == 'jpg' ||
                  document.documentType == 'jpeg' || 
                  document.documentType == 'image/jpeg'">
                  <img width="40" src="../../../../../assets/icons/fileType/014-jpg.svg" alt="jpg File"/>
              </span>

              <span class="type" *ngIf="document.documentType == 'png' ||
                  document.documentType == 'gif' ||
                  document.documentType == 'tiff' ||
                  document.documentType == 'webp' ||
                  document.documentType == 'bmp'">
                  <img width="40" src="../../../../../assets/icons/fileType/020-png.svg" alt="png File"/>
               </span>

              <span class="type" *ngIf="document.documentType == 'txt'">
                <img width="40" src="../../../../../assets/icons/fileType/text_icon.svg" alt="txt File"/>
              </span>

              <span class="type" *ngIf="document.documentType == 'ppt' ||
                  document.documentType == 'pptx'">
                  <img width="40" src="../../../../../assets/icons/fileType/021-ppt.svg" alt="ppt File"/>
              </span>

                <p>{{document.placeholderName}}</p>
              <input type="file" [disabled]="status" matTooltipClass="tooltip" matTooltip="{{document.placeholderName}}"
              (change)="UploadFile($event,document)">
            </div>
            <div class="uplsub">
              <input [disabled]="status" #Input hidden="true" type="file" onclick="this.value=null" (change)="UploadFile($event,document)"/>
              <button [disabled]="status" class="upload" mat-stroked-button color="primary" matTooltip="Upload" (click)="Input.click()" matTooltipClass="tooltip">                
                Upload
              </button>  
              
            </div>
          </div>
        </ng-container>
        </li>

       
      </ul>
    </div>

    <div class="mat-dialog-actions">
      <button mat-flat-button color="primary" [disabled]="!ShowSubmitButton" (click)="SubmitDocument(true)">Save & Submit</button>
      <button mat-flat-button color="primary" [disabled]="!ShowSubmitButton" (click)="SubmitDocument(false)">Save</button>
    </div>
    

  </div>
<!-- For requested docuemnts -->



</div>


<div class="progress-loader" *ngIf="spinner">

  <div class="lds-ripple" ><div></div><div></div></div>
</div>

